import { createSlice } from '@reduxjs/toolkit';
export const queriesManagerSlice = createSlice({
  name: 'quriesManager',
  initialState: {
    saveQueryResponse: [],
    queryName: '',
    documentName: 'Untitled',
    queryData: [],
    setQueriesLoader: true,
    totalMyQureies: 0,
    totalBritiveQureies: 0,
    description: '',
    queryId: -1
  },
  reducers: {
    pushSavedQueryResponse: (state, action) => {
      state.saveQueryResponse = action.payload;
    },
    pushSavedQueryData: (state, action) => {
      state.queryData = action.payload;
    },
    pushSavedQueryName: (state, action) => {
      state.queryName = action.payload;
    },
    pushInitialDocumentName: (state, action) => {
      state.documentName = action.payload;
    },
    pushQueriesLoader: (state, action) => {
      state.setQueriesLoader = action.payload;
    },
    pushTotalMyQureies: (state, action) => {
      state.totalMyQureies = action.payload;
    },
    pushTotalBritiveQureies: (state, action) => {
      state.totalBritiveQureies = action.payload;
    },
    pushSavedQueryDescription: (state, action) => {
      state.description = action.payload;
    },
    pushSavedQueryId: (state, action) => {
      state.queryId = action.payload;
    },
    resetQueriesManager: state => {
      state.saveQueryResponse = [], state.queryName = '', state.documentName = 'Untitled', state.queryData = [], state.setQueriesLoader = true, state.totalMyQureies = 0, state.totalBritiveQureies = 0, state.description = '', state.queryId = -1;
    },
    resetDeleteQueriesManager: state => {
      state.queryName = '', state.documentName = 'Untitled', state.description = '', state.queryId = -1;
    }
  }
});
export const {
  pushSavedQueryResponse,
  pushSavedQueryData,
  pushSavedQueryName,
  pushInitialDocumentName,
  pushQueriesLoader,
  pushTotalMyQureies,
  pushTotalBritiveQureies,
  pushSavedQueryDescription,
  pushSavedQueryId,
  resetQueriesManager,
  resetDeleteQueriesManager
} = queriesManagerSlice.actions;
export default queriesManagerSlice.reducer;